var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4071 10.1394L11.5048 15.0416L10.2243 13.7611L12.9406 11.0448L5.16675 11.0448L5.16675 9.23395L12.9407 9.23395L10.2243 6.51764L11.5048 5.23715L16.4071 10.1394Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5994 0.179565C16.1 0.179565 20.5592 4.63873 20.5592 10.1394C20.5592 15.64 16.1 20.0992 10.5994 20.0992C5.09872 20.0992 0.639554 15.64 0.639555 10.1394C0.639555 4.63873 5.09872 0.179565 10.5994 0.179565ZM18.7483 10.1394C18.7483 5.63885 15.0999 1.99044 10.5994 1.99044C6.09884 1.99044 2.45043 5.63885 2.45043 10.1394C2.45043 14.6399 6.09884 18.2883 10.5994 18.2883C15.0999 18.2883 18.7483 14.6399 18.7483 10.1394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.fd9d5a74d4beb1b5b4f48427c9590dc8.svg";
export { ForwardRef as ReactComponent };